export default "__VITE_ASSET__jgFA33gG__"